var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M21.42 8.882a10 10 0 0 0-9.169-6c-5.185 0-9.448 3.947-9.95 9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.25 8.882h4.4a.6.6 0 0 0 .6-.6v-4.4M3.133 16.882c1.543 3.532 5.067 6 9.168 6 5.185 0 9.449-3.947 9.95-9"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M7.3 16.882H2.9a.6.6 0 0 0-.6.6v4.4"
})));
export default SvgRefresh;